const canonicalDomain = require('module/user/helpers/canonical_domain')
const log = require('log').create('canonicalUrl') // eslint-disable-line

/**
 * canonicalUrl - returns user's domain URL or about.me URL
 *
 * @param  {JSON} user JSON user object
 */
module.exports = function canonicalUrl(user, aboutme_domain) {
    const domain = canonicalDomain(user)

    if (domain && domain.domain) return `https://${domain.domain}`

    // otherwise, about.me/username
    return `${aboutme_domain}/${user.user_name}`
}
